import { RouteStop } from "@mapmycustomers/shared/types/entity/Route";

/**
 * A route with no stops must NOT read as complete: callers would preview an empty `stopTime[]`,
 * which the BE rejects. Takes the stop array so the editor's `EditorRouteStop[]` fits unadapted.
 */
const isRouteComplete = (
  stops: null | ReadonlyArray<Pick<RouteStop, "checkedOff">> | undefined
): boolean => !!stops?.length && stops.every((stop) => !!stop.checkedOff);

export default isRouteComplete;
